import React from 'react';
import { Form, Input, notification, Spin } from 'antd';
import { Button, Icon } from 'semantic-ui-react';
import { observer } from 'mobx-react';
import moment from 'moment';
import './ModalCreate.scss';
import Modal from '../../shared/Modal';
import AMATimeUnitSettingStore from './Store';
import { getAMATimeUnitSettingInfo, saveAMATimeUnitSetting } from './Service';
import { formatDate } from '../../../utils/functions';

@observer
class ModalCreate extends React.Component {
  state = {
    loading: true,
    data: null,
  };

  handleSave = () => {
    const { data } = this.state;
    if (data.TimeUnit < 0 || data.StartTime < 0 || !data.EndTime < 0) {
      notification.destroy();
      notification.error({
        message: 'Error',
        description: 'Invalid form',
        duration: 3,
      });
    } else {
      var submitData = data;
      Promise.all([saveAMATimeUnitSetting(submitData)])
        .then(([response]) => {
          if (response.status === 'success') {
            notification.destroy();
            notification.success({
              message: 'Success',
              description: 'Data has been saved successfully.',
              duration: 3,
            });
            AMATimeUnitSettingStore.refetch({}, true);
            this.props.onCancel();
          }
        })
        .catch(() => {
          notification.destroy();
          notification.error({
            message: 'Error',
            description: 'An error occurred, please try again',
            duration: 3,
          });
        });
    }
  };
  componentDidMount() {
    const { id } = AMATimeUnitSettingStore.modalParams;
    if (id) {
      Promise.all([getAMATimeUnitSettingInfo(id)]).then(([itemInfo]) => {
        this.setState({
          loading: false,
          data: itemInfo.objItem,
        });
      });
    } else {
      this.setState({
        loading: false,
        data: {
          Id: 0,
          Key: '',
          Label: '',
          Target: 0,
        },
      });
    }
  }

  handleFieldChange = fieldName => event => {
    const { data } = this.state;
    const value = event ? (event.target ? event.target.value : event) : null;
    this.setState({
      data: {
        ...data,
        [fieldName]: value,
      },
    });
  };

  convertDate = dateStr => {
    if (dateStr) {
      if (typeof dateStr === 'string') {
        if (dateStr.search('/Date') !== -1) {
          const date = formatDate(dateStr, true);
          return moment(date, 'DD MMM YYYY, HH:mm');
        }
        return moment(dateStr, 'DD/MM/YYYY');
      }
      return dateStr;
    }
    return null;
  };

  render() {
    const { record, id } = AMATimeUnitSettingStore.modalParams;
    const { open } = AMATimeUnitSettingStore;
    const { data, loading } = this.state;

    return (
      <Modal
        width={800}
        onCancel={this.props.onCancel}
        visible={open}
        footer={
          <React.Fragment>
            <Button color="blue" onClick={this.handleSave}>
              Save
            </Button>
            <Button color="red" onClick={this.props.onCancel}>
              <Icon name="close" />
              Close
            </Button>
          </React.Fragment>
        }
        title={!id ? 'Add Aftercare Rule' : record.Name}
      >
        {loading ? (
          <Spin size="large" />
        ) : (
          <Form name="conversation" className="conversation-form">
            <Form.Item
              label="Time Unit"
              required
              validateStatus={!data.TimeUnit || data.TimeUnit < 0 ? 'error' : null}
              help={!data.Name ? 'This field is required' : null}
            >
              <Input type="number" value={data.TimeUnit} onChange={this.handleFieldChange('TimeUnit')} />
            </Form.Item>
            <Form.Item label="Time Unit Rule">
              <Input.TextArea rows={4} value={data.TimeUnitRule} onChange={this.handleFieldChange('TimeUnitRule')} />
            </Form.Item>
            <Form.Item
              label="Start Time (minutes)"
              required
              validateStatus={data.StartTime < 0 ? 'error' : null}
              help={!data.Name ? 'This field is required' : null}
            >
              <Input type="number" value={data.StartTime} onChange={this.handleFieldChange('StartTime')} />
            </Form.Item>
            <Form.Item
              label="End Time (minutes)"
              required
              validateStatus={!data.EndTime || data.EndTime < 0 ? 'error' : null}
              help={!data.Name ? 'This field is required' : null}
            >
              <Input type="number" value={data.EndTime} onChange={this.handleFieldChange('EndTime')} />
            </Form.Item>
          </Form>
        )}
      </Modal>
    );
  }
}

export default ModalCreate;
